module.exports = __webpack_public_path__ + "static/img/wxxcx.a900d78c.jpg";